import request from '../utils/request'
const getToken = () => {
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}')
  return userInfo?.token || ''
}

// 登录
const login = (username, phone, password, type) => request.post('login', { username, phone, password, type: 'agent' }, {})

// 重置密码
const resetPassword = (captcha, password, phone, type) => request.post('user/updatePassword', { captcha, password, phone, type: 'agent' }, { token: `Bearer ${getToken()}` })

// 更新头像
const updateUserAvatar = (avatar, id) => request.get('user/updateAvatar', { avatar, id }, { token: `Bearer ${getToken()}` })

// 获取验证码
const getVerificationCode = (phone, type) => request.get('send-code', { phone, type }, {})

// 分析链接内容生成行业标签
const analysislink = (url) => request.post('agent/ipbrain/analyzeIndustries', { url }, { token: `Bearer ${getToken()}` })

// 分析视频链接
const analyVideo = (url) => request.post('agent/ipbrain/analyzeIndustrieVideo', { url }, { token: `Bearer ${getToken()}` })

// 根据行业信息生成选题（previousTopics 非空时传入，防止重复）
const analysisIndustry = (industries, previousTopics) => request.post('agent/ipbrain/generateTopics',
  { industries, ...(previousTopics && previousTopics.length ? { previousTopics } : {}) },
  { token: `Bearer ${getToken()}` })

// 生成音频（audioConfig: content, emotionMode: same|vector, emotionVector?: number[], voiceUrl, language, durationFactor）
const createAudio = (audioConfig) => request.post('agent/media/generateAudio', audioConfig, { token: `Bearer ${getToken()}` })

// 查询TTS音频生成任务状态
const queryTTSAudioStatus = (taskId) => request.get('agent/media/audioStatus', { taskId }, { token: `Bearer ${getToken()}` })

// 生成数字人视频（超时设置为2小时）
const createVideo = (videoConfig) => request.post('agent/media/generateVideo', videoConfig, { token: `Bearer ${getToken()}`, timeout: 7200000 })

// 视频高清修复
const videoRepair = (videoFilename, videoUrl) => request.post('agent/media/enhanceVideo', { videoFilename, videoUrl }, { token: `Bearer ${getToken()}` })

// 视频编辑
const videoEdit = (requestReq) => request.post('agent/video/edit', requestReq, { token: `Bearer ${getToken()}` })

// 查询视频编辑任务状态
const queryVideoEditStatus = (taskId) => request.get('agent/video/status', { taskId }, { token: `Bearer ${getToken()}` })

// 生成视频封面
const videoCover = (requestReq) => request.post('agent/video/generateCover', requestReq, { token: `Bearer ${getToken()}` })

// 检查软件更新
const checkSoftwareUpdate = () => request.get('agent/ipbrain/checkUpdate', {}, { token: `Bearer ${getToken()}` })

// 定制音色
// eslint-disable-next-line camelcase
const customDigitalVideo = (customisedAudioVO) => request.post('customisedAudio/creatCustomisedAudio', customisedAudioVO, { token: `Bearer ${getToken()}` })

// 删除用户定制的音色
const deleteAudio = (id) => request.get('customisedAudio/deleteCustomisedAudioById', { id }, { token: `Bearer ${getToken()}` })

// 生成的数字人保存到库里
const conserveDigitalHuman = (DingZhiDigitalHuman) => request.post('digitalhuman/insertDigitalHuman', DingZhiDigitalHuman, { token: `Bearer ${getToken()}` })

// 删除用户定制的数字人
const deleteDigitalHuman = (id) => request.get('digitalhuman/deletedDigitalHumanById', { id }, { token: `Bearer ${getToken()}` })

// 查询该用户定制的数字人列表
const getDigitalHumanList = (userId) => request.get('digitalhuman/getDigitalHumanByUserId', { userId }, { token: `Bearer ${getToken()}` })

// 查询该用户定制的声音列表
const getAudioList = (userId) => request.get('customisedAudio/getCustomisedAudioByUserId', { userId }, { token: `Bearer ${getToken()}` })

// 获取公共数字人列表
const getPublicDigitalHumanList = () => request.get('digitalhuman/getPublicDigitalHumanByType', {}, { token: `Bearer ${getToken()}` })

// 获取公共声音列表
const getPublicAudioList = () => request.get('customisedAudio/getPublicAudioByType', {}, { token: `Bearer ${getToken()}` })

// 修改用户信息
const updateUserInfo = (name) => request.get('user/updateNickname', { name }, { token: `Bearer ${getToken()}` })

// 解析ppt
const parsePPT = (url, type, userId) => request.post('ppt/parsePPT', { url, type, userId }, { token: `Bearer ${getToken()}` })

// 保存用户商品信息
const saveGoods = (goodsInfo) => request.post('agent/media/userGoods', { goodsInfo }, { token: `Bearer ${getToken()}` })

// 获取用户商品信息
const getGoods = () => request.get('agent/media/userGoods', {}, { token: `Bearer ${getToken()}` })

// 获取音频历史列表
const getAudioHistory = (page, pageSize) => request.get('agent/media/audioHistory', { page, pageSize }, { token: `Bearer ${getToken()}` })

// 获取封面生成历史
const getCoverHistory = (page, pageSize) => request.get('agent/video/coverHistory', { page, pageSize }, { token: `Bearer ${getToken()}` })

// 获取视频生成列表
const getVideoHistory = (page, pageSize) => request.get('agent/video/editHistory', { page, pageSize }, { token: `Bearer ${getToken()}` })

// 取消视频生成
const cancelEdit = () => request.post('agent/video/cancelEdit', {}, { token: `Bearer ${getToken()}` })

// 加入/移除分组
const addOrRemoveGroup = (groupId, groupName, type, itemId) => request.post('agent/media/group/assign', { groupId, groupName, type, itemId }, { token: `Bearer ${getToken()}` })

// 创建分组
const createGroup = (groupName, type) => request.post('agent/media/group/create', { groupName, type }, { token: `Bearer ${getToken()}` })

// 删除分组
const deleteGroup = (groupId, type) => request.post('agent/media/group/delete', { groupId, type }, { token: `Bearer ${getToken()}` })

// 重命名分组
const renameGroup = (groupId, groupName, type) => request.post('agent/media/group/rename', { groupId, groupName, type }, { token: `Bearer ${getToken()}` })

// 获取分组列表
const getGroupList = (type) => request.get('agent/media/group/list', { type }, { token: `Bearer ${getToken()}` })

// 获取套餐目录
const getPackageList = () => request.get('agent/plan/list', {}, { token: `Bearer ${getToken()}` })

// 查询套餐流水
const getPackageFlow = (limit) => request.get('agent/plan/ledger', { limit }, { token: `Bearer ${getToken()}` })

// 查询当前用户的套餐与余额（agent/plan/me）
const getMyPlan = () => request.get('agent/plan/me', {}, { token: `Bearer ${getToken()}` })
// 兼容旧命名
const buyPackage = getMyPlan

// 支付宝下单（PreCreate 二维码）
const aliPayPreCreate = (planId) => request.post('agent/plan/order/alipay', { planId }, { token: `Bearer ${getToken()}` })

// 查询订单状态并触发套餐应用
const queryOrderStatus = (orderId) => request.get('agent/plan/order/status', { orderId }, { token: `Bearer ${getToken()}` })

// 微信下单（Native 二维码）
const wechatPayNative = (planId) => request.post('agent/plan/order/wechat', { planId }, { token: `Bearer ${getToken()}` })

export {
  login,
  resetPassword,
  analysislink,
  getVerificationCode,
  analyVideo,
  analysisIndustry,
  createAudio,
  queryTTSAudioStatus,
  createVideo,
  videoRepair,
  videoEdit,
  queryVideoEditStatus,
  videoCover,
  updateUserAvatar,
  checkSoftwareUpdate,
  customDigitalVideo,
  deleteAudio,
  conserveDigitalHuman,
  deleteDigitalHuman,
  getDigitalHumanList,
  getAudioList,
  getPublicDigitalHumanList,
  updateUserInfo,
  getPublicAudioList,
  parsePPT,
  saveGoods,
  getGoods,
  getAudioHistory,
  getCoverHistory,
  getVideoHistory,
  cancelEdit,
  addOrRemoveGroup,
  createGroup,
  deleteGroup,
  renameGroup,
  getGroupList,
  getPackageList,
  getPackageFlow,
  getMyPlan,
  buyPackage,
  aliPayPreCreate,
  queryOrderStatus,
  wechatPayNative
}
